import { type ApprovedOrderItemConstructor } from '@webapp/modules/purchasing/entities/ApprovedOrderItem'
import { type OrderItemStatusEnum } from '@webapp/modules/purchasing/entities/enums/OrderItemStatusEnum'
import { mapApprovedOrderItemAccountApiModel } from './mapApprovedOrderItemApiModel'
import { type ApprovedOrderSiblingItemApiModel } from '../api-models/OrderItemsResponseApiModel'

/**
 * Maps an order-item row embedded in GET /api/v3/orders/{orderNumber}/ to the
 * summary constructor. Sibling rows carry no submitted_date/currency/requester
 * — those map to null; orderUuid is derived from the parent order's uuid.
 */
export const mapApprovedOrderSiblingItemApiModel = (
  apiModel: ApprovedOrderSiblingItemApiModel,
  orderUuid: string
): ApprovedOrderItemConstructor => ({
  id: apiModel.id,
  orderId: apiModel.orderNum,
  orderNumber: apiModel.order_number ?? apiModel.orderNum,
  lineNumber: apiModel.num,
  name: apiModel.name,
  quantity: apiModel.quantity,
  price: apiModel.price,
  totalCost: apiModel.total_cost,
  status: apiModel.status as OrderItemStatusEnum,
  orderUuid,
  approvedDate: apiModel.approved_datetime,
  submittedDate: null,
  hasSiblingItems: apiModel.has_sibling_items,
  lineComment: apiModel.lineComment ?? null,
  orderDescription: null,
  currency: null,
  requester: null,
  account: mapApprovedOrderItemAccountApiModel(apiModel.account),
})
